import { connect } from '@client/decorators/common';
import { createSelectorFactory } from '@client/selectors/lib';
import { getShowById } from '@client/selectors/entities/shows';
import { startFetchMinimalShow, unsubscribeShow } from '@client/slices/entities/shows.reducer';
import { isOwnerOrCollaboratorOrModerator } from '@client/selectors/helpers/session';
import { withData } from '@client/decorators/common/withData';
import { withShowListeners } from './with-show.listeners';
import type { WithDataOptions } from '@client/decorators/common/withData';
import type { RootState } from '@client/store';

/**
 * Decorate a component with a call to fetch basic show info
 */

const getShowByIdFactory = createSelectorFactory(getShowById);

const mapDispatchToProps = {
  fetch: startFetchMinimalShow,
  unfetch: unsubscribeShow,
};

const mapStateToProps = () => {
  const getShowByIdSelector = getShowByIdFactory();

  return (state: RootState, { id }) => {
    const show = getShowByIdSelector(state, id);

    return {
      current: id,
      canAccess: show?.publicFetched && show?.privateFetched && isOwnerOrCollaboratorOrModerator(state, show),
      ...show,
    };
  };
};

export const withShowFactory = <TProps>(options?: WithDataOptions) => (
  WrappedComponent: React.ElementType<TProps & ReturnType<ReturnType<typeof mapStateToProps>>>,
) => connect(mapStateToProps, mapDispatchToProps)(withData(WrappedComponent, options, withShowListeners));
